import type { ReactNode } from "react";
import { TILE_TESTID_PREFIX } from "@/lib/tileIds";
import "./HomeTile.css";

/**
 * ef-061-4 — the wrapper every rendered Home tile sits in. It carries the documented test contract
 * `data-testid="home-tile-<id>"` (`lib/tileIds.ts`) and NOTHING ELSE a person or a screen reader can see: no
 * role, no label, no heading. "Cash on hand", "Next payroll" and the rest are role+name pairs other Home specs
 * already locate, and a wrapper that added a region or group with a colliding name would break them.
 * Nothing else on Home uses the `home-tile-` prefix.
 */
export function HomeTile({ id, children }: { id: string; children: ReactNode }) {
  return (
    <div className="home-tile" data-testid={`${TILE_TESTID_PREFIX}${id}`}>
      {children}
    </div>
  );
}
